import './side-bar-session-style.css';
import { Ripple } from 'primereact/ripple';
import { Divider } from 'primereact/divider';
import { ExamSessionDetails } from '../../../../../../../api/types/programs/course/exams/response/exam-metadata';
import { SideBarSessionItem } from './componenets/side-bar-session-item';
import { deleteExamSessionOperation } from './operations/delete-exam-session-operation';
import globalProgramStore from '../../../../../../../stores/program-store';
import globalCourseStore from '../../../../../../../stores/global-course-store';
import { useState } from 'react';

interface SideBarSessionsDatamodel {
  sessions: ExamSessionDetails[];
  setSessionIndex: (index: number) => any;
  selectedIndex: number;
  handleCreateNewSession: () => any;
  createNewSessionLoading: boolean;
  examId: number;
  setSessionDetails: (sessions: ExamSessionDetails[]) => any;
}
export const SideBarSessions: React.FC<SideBarSessionsDatamodel> = ({
  sessions,
  setSessionIndex,
  selectedIndex,
  handleCreateNewSession,
  createNewSessionLoading,
  examId,
  setSessionDetails,
}) => {
  const [examSessionIdLoading, setExamSessionIdLoading] = useState<
    number | null
  >(null);

  const handleDelete = async (session: ExamSessionDetails) => {
    const currentProgramId = globalProgramStore.getCurrentId();
    const currentCourseId = globalCourseStore.getCurrentCourse()?.metadata.id;
    console.log(`XXXXXXX data res hello world: ${session.examId}`);
    await deleteExamSessionOperation(
      currentProgramId,
      currentCourseId,
      examId,
      session.id,
      setExamSessionIdLoading,
      setSessionDetails,
    );
  };

  return (
    <div
      className={'exam-side-bar'}
      style={{
        height: '100%',
        width: '200px',
        maxWidth: '200px',
        minWidth: '200px',
        /*borderTopLeftRadius: '36px',*/
        /*backgroundColor: '#30363c',*/
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        paddingBottom: '16px',
      }}
    >
      <div>
        <div
          style={{
            height: '80px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <label>מבחן</label>
        </div>
        {sessions.map((item, index) => (
          <SideBarSessionItem
            selectedIndex={selectedIndex}
            setSessionIndex={setSessionIndex}
            id="item1"
            index={index}
            handleDelete={() => handleDelete(item)}
          />
        ))}
      </div>

      <div
        onClick={handleCreateNewSession}
        style={{ display: 'flex', flexDirection: 'column' }}
      >
        <Divider style={{ height: '2px' }} />
        <div
          className={`side-bar-session-item p-ripple`} // Add p-ripple class
          style={{
            height: '45px',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            paddingRight: '8px',
            gap: '4px',
            borderRadius: '4px',
            cursor: 'pointer', // Add this to indicate it's clickable
          }}
        >
          {/*<i className="pi pi-plus mr-2"></i>*/}
          {createNewSessionLoading ? (
            <i className="pi pi-spinner pi-spin mr-2"></i>
          ) : (
            <i className="pi pi-plus mr-2"></i>
          )}

          <span className="font-medium">הוספת מועד</span>
          <Ripple />
        </div>
      </div>
    </div>
  );
};
